<template>
  <component :is="computedAs" :href="href" class="menu-item" v-on="$listeners">
    <Row
      :has-line="false"
      :chevron="chevron"
      :icon="icon"
      class="menu-item__row"
    >
      <template #top-left>
        <BaseText size="lg">
          <slot />
        </BaseText>
      </template>
      <template #top-right>
        <slot name="right" />
      </template>
    </Row>
  </component>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Row, BaseText } from '@warrenbrasil/nebraska-web';

@Component({
  components: { Row, BaseText }
})
export default class MenuItem extends Vue {
  @Prop({ type: String })
  private href!: string;

  @Prop({ type: Boolean })
  private chevron!: boolean;

  @Prop({ type: String })
  private icon!: string;

  private get computedAs() {
    if (this.href) {
      return 'a';
    }

    return 'button';
  }
}
</script>

<style lang="less" scoped>
.menu-item {
  width: 100%;

  &__row {
    border-radius: 0;
    margin: 0;
    padding: 0 @size-spacing-x500;

    /deep/ .icon {
      margin: 0;
    }

    &:hover {
      background-color: @background-hover;
    }
  }
}
</style>
